<template>
  <base-slide-over ref="slideover" title="Edit User" size="lg" style="z-index: 10000">
    <base-form class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid" ref="form" @submit.prevent>
      <base-text-field label="Name" v-model="name" class="tw-mt-3" required :maxlength="255" />
      <div class="tw-mt-2 tw-mb-1">Roles</div>
      <base-radio-group :value="selectedRole" class="tw-space-y-1" required>
        <base-radio value="business_administrator" name="editRole" v-model="selectedRole">Administrator</base-radio>
        <base-radio value="business_management" name="editRole" v-model="selectedRole">Management</base-radio>
        <base-radio value="business_operations" name="editRole" v-model="selectedRole">Operations</base-radio>
      </base-radio-group>
      <!-- Secondary Role select -->
      <base-select
        class="tw-mt-4"
        v-if="cobrandId === 'rx-harmony' && selectedRole === 'business_management'"
        label="Secondary Role (optional)"
        :options="secondaryRoleOptions"
        v-model="secondaryRole"
        placeholder="Select secondary role"
        valueKey="value"
        labelKey="text"
      />

      <div class="tw-flex tw-my-4">
        <div class="tw-text-sm tw-mr-2 tw-my-auto tw-text-gray-800 tw-cursor-pointer">All Locations</div>
        <base-toggle v-model="isAllLocations" :disabled="isLocationFiltered === true" />
      </div>
      <div class="tw-my-6" v-show="!isAllLocations">
        <base-advanced-select label="Locations" placeholder="Select one or more locations" :options="locations" v-model="selectedLocations" label-key="name" multiple />
        <div class="tw-text-xs tw-mt-2 tw-text-gray-500">If you don't select any locations, all locations will be visible to this user.</div>
      </div>
      <base-text-field label="New Pin" placeholder="Enter pin" v-model="newPin" class="tw-mt-6" :maxLength="4" :minLength="4" @keypress="isNumber" :rules="rules" />
      <!-- <base-text-field label="NPI" placeholder="Enter user's NPI" v-model="npi" class="tw-mt-3" :maxLength="10" />
      <base-text-field label="DEA" placeholder="Enter user's DEA" v-model="dea" class="tw-mt-7" :maxLength="9" /> -->
    </base-form>
    <inline-error id="location-error" :title="errorTitle" :message="errorMessage" :error="error" />
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" class="tw-w-auto tw-mr-3" @click="close">
          Cancel
        </base-button>
        <base-button :loading="isLoading" :disabled="!isFormValid" class="tw-w-auto" @click="submit">
          Save
        </base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessUsersEdit",
  components: { InlineError },
  props: {
    businessId: String,
  },
  data: function() {
    return {
      isLoading: false,
      isFormValid: true,
      userId: null,
      name: null,
      npi: null,
      dea: null,
      email: null,
      selectedRole: null,
      newPin: null,
      isAllLocations: false,
      selectedLocations: [],
      secondaryRole: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
      rules: [() => this.newPin == null || (this.newPin && this.newPin.toString().length === 4) || "Pin must be 4 digits"],
    };
  },
  computed: {
    ...mapGetters("location", ["locations"]),
    ...mapGetters("role", ["isLocationFiltered"]),
    ...mapGetters("organization", ["cobrandId"]),
    secondaryRoleOptions() {
      return [{ value: "psc", text: "PSC" }];
    },
  },
  methods: {
    reset() {
      this.isLoading = true;
      this.name = null;
      this.npi = null;
      this.dea = null;
      this.email = null;
      this.newPin = null;
      this.selectedRole = null;
      this.isAllLocations = false;
      this.selectedLocations = [];
      this.secondaryRole = null;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;

      this.$axios
        .get(`/businesses/${this.businessId}/users/${this.userId}`)
        .then((res) => {
          this.isLoading = false;
          this.name = res.data.name;
          this.email = res.data.email;
          this.selectedRole = res.data.roles[0] || null;
          this.selectedLocations = this.locations.filter((item) => res.data.locationFilters.includes(item.businessLocationId));
          this.isAllLocations = !this.selectedLocations.length;
          this.npi = res.data.npi;
          this.dea = res.data.dea;
          this.secondaryRole = res.data.secondaryRole;
        })
        .catch((err) => {
          this.isLoading = false;
          this.errorTitle = `Failed to get user information`;
          this.errorMessage = `Failed to get user information.`;
          this.error = err;
        });
    },
    show(userId) {
      this.userId = userId;
      this.reset();
      this.$refs.slideover.show();
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;

      if (this.selectedLocations.length > 0) {
        var locationStrings = this.selectedLocations.map(function(location) {
          return location["businessLocationId"];
        });
      }

      if (this.selectedRole !== "business_management") {
        this.secondaryRole = null;
      }

      this.$axios
        .put(`/businesses/${this.businessId}/users/${this.userId}`, {
          roles: [this.selectedRole],
          pin: this.newPin,
          filterLocations: this.isAllLocations ? [] : locationStrings,
          fullName: this.name,
          npi: this.npi,
          dea: this.dea,
          secondaryRole: this.secondaryRole || null,
        })
        .then(() => {
          this.isLoading = false;
          this.newPin = null;
          this.close();
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "User Updated", message: "User updated successfully" });
          this.$emit("saved");
        })
        .catch((err) => {
          this.isLoading = false;
          this.errorTitle = `Failed to save user information`;
          this.errorMessage = `The user's information could not be saved. Please try again.`;
          this.error = err;
        });
    },
    close() {
      this.$refs.slideover.hide();
    },
    isNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
  },
};
</script>
